import { gql } from '@apollo/client'

import { COURSE_TYPE_NODE_FRAGMENT } from '../fragments'

const SET_IS_CURATION_ENABLED_COURSE_TYPE_MUTATION = gql`
  mutation setIsCurationEnabledCourseType(
    $id: ID!
    $isCurationEnabled: Boolean!
  ) {
    setIsCurationEnabledCourseType(
      id: $id
      isCurationEnabled: $isCurationEnabled
    ) {
      ...CourseTypeNodeFragment
    }
  }
  ${COURSE_TYPE_NODE_FRAGMENT}
`

export default SET_IS_CURATION_ENABLED_COURSE_TYPE_MUTATION
